"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.certificatesToDepositLovelaces = exports.certToDepositLovelaces = void 0;
var CertificateType_1 = require("./CertificateType.js");
var ada = BigInt(1000000);
function certToDepositLovelaces(cert) {
    var t = cert.certType;
    if (t === CertificateType_1.CertificateType.StakeRegistration)
        return BigInt(2) * ada;
    if (t === CertificateType_1.CertificateType.StakeDeRegistration)
        return BigInt(-2) * ada;
    if (t === CertificateType_1.CertificateType.PoolRegistration)
        return BigInt(500) * ada;
    if (t === CertificateType_1.CertificateType.PoolRetirement)
        return BigInt(-500) * ada;
    return BigInt(0);
}
exports.certToDepositLovelaces = certToDepositLovelaces;
function certificatesToDepositLovelaces(certs) {
    return certs.reduce(function (a, b) { return a + certToDepositLovelaces(b); }, BigInt(0));
}
exports.certificatesToDepositLovelaces = certificatesToDepositLovelaces;
